var ctaEventDataLayer = function(ctaElement, sitecoreItem) {
  var dataLayer = (window.dataLayer = window.dataLayer || []);

  var ctaEvent = {
    event: "click_cta"
  };

  var baseURL = window.location.origin;

  var relativeURL = ctaElement.getAttribute("href");

  if (relativeURL.startsWith("http") || relativeURL === baseURL) {
    ctaEvent.link_url = relativeURL;
  } else {
    ctaEvent.link_url = baseURL + relativeURL;
  }

  ctaEvent.cta_category = relativeURL
    .substring(relativeURL.lastIndexOf("/") + 1)
    .split("-")
    .join(" ");

  ctaEvent.element_description = ctaElement.textContent.trim();
  
  ctaEvent.sitecore_item_name = sitecoreItem;

  dataLayer.push(ctaEvent);

  return;
};

export default ctaEventDataLayer;
